import ReactDOM from "react-dom";

const VideoPopup = ({ onClose, currentItemSrc }: any) => {
  return ReactDOM.createPortal(
    <div className="popup-overlay" onClick={onClose}>
      <div className="popup-content" onClick={(e) => e.stopPropagation()}>
        <iframe
          //   width="100%"
          //   height="100%"
          src={currentItemSrc}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          allowFullScreen
          className="video-popup"
        ></iframe>
      </div>
    </div>,
    document.body // Render the popup into the body element
  );
};

export default VideoPopup;
